import styled from '@emotion/styled';

const PriceTableWrapper = styled.div`
  display: flex;
  flex-direction: column;

  .title {
    margin-bottom: 24px;
    margin-top: 0;

    @media (min-width: ${(props) => props.theme.breakpoints.tablet}) {
      margin-bottom: 30px;
    }
  }
`;

const StyledPriceTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: Inter;
  td,
  th {
    text-align: center;
    padding: 15px 0;
    word-break: break-word;
    font-weight: normal;
    border-right: 1px solid ${(props) => props.theme.colors.grey._300};
    border-bottom: 1px solid ${(props) => props.theme.colors.grey._300};
  }

  .location-name {
    text-align: center;

    @media (min-width: ${(props) => props.theme.breakpoints.tablet}) {
      text-align: left;
    }
  }

  td {
    font-size: 16px;
    line-height: 28px;

    @media (min-width: ${(props) => props.theme.breakpoints.tablet}) {
      font-size: 18px;
      line-height: 30px;
    }
  }

  th {
    font-size: 14px;
    line-height: 28px;
    word-break: initial;
    hyphens: auto;

    &:nth-of-type(1n + 2) {
      padding-right: 4px;
    }

    @media (min-width: ${(props) => props.theme.breakpoints.tablet}) {
      font-size: 18px;
      line-height: 30px;
    }
  }

  thead {
    color: ${(props) => props.theme.colors.grey};

    tr {
      border-top: 1px solid ${(props) => props.theme.colors.grey._300};
    }
  }
  tbody {
    color: ${(props) => props.theme.colors.primary};
    border-top: 2px solid ${(props) => props.theme.colors.grey._300};

    .location-name a {
      color: ${(props) => props.theme.colors.primary};
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .price-quadratmeter {
    width: 150px;

    @media (min-width: ${(props) => props.theme.breakpoints.tablet}) {
      width: 300px;
    }
  }
`;

const PriceTableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  position: relative;
`;

const ExpandListButton = styled.span`
  display: inline-block;
  padding: 8px;
  cursor: pointer;

  &:after {
    content: '';
    display: block;
    border-top: 2px solid #4a4a4a;
    border-right: 2px solid #4a4a4a;
    -webkit-transform: rotate(135deg);
    -ms-transform: rotate(135deg);
    transform: rotate(135deg);
    width: 8px;
    height: 8px;
    transition: transform 0.2s ease-in-out;
  }

  &.expanded:after {
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
`;

const ShowMore = styled.div`
  text-align: center;
  padding: 24px 0;
  margin: 0 -16px;

  @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
    margin: 0 -24px;
  }

  button {
    border: none;
    background: white;
    color: ${(props) => props.theme.colors.primary};
    font-family: Inter;
    font-size: 18px;
    line-height: 30px;
    font-weight: bold;
    border-bottom: 3px solid ${(props) => props.theme.colors.yellow._400};
    cursor: pointer;
  }
`;

export { PriceTableWrapper, PriceTableHeader, ExpandListButton, ShowMore, StyledPriceTable };
